import { formatCurrency } from "../../lib/utils";

const qty = (q) => (q === null || q === undefined ? "—" : Number(q).toLocaleString("pt-PT", { maximumFractionDigits: 3 }));
const signed = (q) => (q === null || q === undefined ? "—" : q > 0 ? `+${qty(q)}` : qty(q));
const tone = (q) => (q > 0 ? "text-emerald-600" : q < 0 ? "text-red-600" : "text-muted-foreground");
const COLS = 10;

export const CashReportProductsTable = ({ report }) => {
  const cats = report?.categories || [];
  const t = report?.totals || {};
  return (
    <div className="rounded-lg border overflow-x-auto" data-testid="cash-report-products">
      <table className="w-full min-w-[820px] text-xs sm:text-sm">
        <thead className="bg-muted/70 text-[11px] uppercase tracking-wide text-muted-foreground">
          <tr>
            <th className="text-left p-2">Categoria</th>
            <th className="text-left p-2">Nome do produto</th>
            <th className="text-center p-2">Un.</th>
            <th className="text-right p-2">Stock inicial</th>
            <th className="text-right p-2">Qtd vendida</th>
            <th className="text-right p-2">Outras E/S</th>
            <th className="text-right p-2" title="Pedidos em aberto neste caixa ou pagos aqui mas lançados em caixa anterior">Pend./outro caixa</th>
            <th className="text-right p-2">Stock final</th>
            <th className="text-right p-2">Preço unit.</th>
            <th className="text-right p-2">Total vendido</th>
          </tr>
        </thead>
        <tbody>
          {cats.length === 0 && <tr><td colSpan={COLS} className="p-6 text-center text-muted-foreground">Sem vendas registadas neste caixa</td></tr>}
          {cats.map((c) => <CategoryRows key={c.category} cat={c} />)}
        </tbody>
        <tfoot>
          <tr className="border-t-2 border-foreground font-bold bg-muted/40" data-testid="cash-report-total-row">
            <td className="p-2" colSpan={4}>TOTAL GERAL · {t.products || 0} produto(s) · {t.orders || 0} pedido(s)</td>
            <td className="p-2 text-right font-mono" data-testid="cash-report-total-units">{qty(t.units)}</td>
            <td colSpan={4} />
            <td className="p-2 text-right font-mono" data-testid="cash-report-total-sales">{formatCurrency(t.sales)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

const CategoryRows = ({ cat }) => (
  <>
    {cat.items.map((it) => {
      const tr = it.track_stock;
      return (
        <tr key={it.product_id || it.product_name} className="border-t" data-testid={`cash-report-item-${it.product_id}`}>
          <td className="p-2 text-xs text-muted-foreground" data-testid={`cash-report-cat-${cat.category}`}>{cat.category}</td>
          <td className="p-2 font-semibold">{it.product_name}{it.discount > 0 && <span className="ml-1 text-[10px] text-red-600 font-normal">PROMO −{formatCurrency(it.discount)}</span>}</td>
          <td className="p-2 text-center text-muted-foreground">{it.unit}</td>
          <td className="p-2 text-right font-mono">{tr ? qty(it.stock_initial) : "—"}</td>
          <td className="p-2 text-right font-mono font-semibold">{qty(it.qty_sold)}</td>
          <td className={`p-2 text-right font-mono ${tone(it.other_net)}`}>{tr ? signed(it.other_net) : "—"}</td>
          <td className={`p-2 text-right font-mono ${tone(it.cross_session_adjust)}`}>{tr && it.cross_session_adjust ? signed(it.cross_session_adjust) : "—"}</td>
          <td className="p-2 text-right font-mono">{tr ? qty(it.stock_final) : "—"}</td>
          <td className="p-2 text-right font-mono">{formatCurrency(it.unit_price)}</td>
          <td className="p-2 text-right font-mono font-semibold">{formatCurrency(it.total_sold)}</td>
        </tr>
      );
    })}
    <tr className="bg-muted/20 text-xs italic text-muted-foreground border-t" data-testid={`cash-report-subtotal-${cat.category}`}>
      <td className="p-1.5 pl-2" colSpan={4}>Subtotal {cat.category} ({cat.items.length} produto(s))</td>
      <td className="p-1.5 text-right font-mono">{qty(cat.qty)}</td>
      <td colSpan={4} />
      <td className="p-1.5 text-right font-mono">{formatCurrency(cat.total)}</td>
    </tr>
  </>
);
